export const appDataKeys = {
    all: ['appData'] as const,
    detail: () => [...appDataKeys.all, 'detail'] as const,
    organization: (orgId: string) => [...appDataKeys.all, 'organization', orgId] as const,
};
